import { render, staticRenderFns } from "./SkeletonPost.vue?vue&type=template&id=761572d5&"
import script from "./SkeletonPost.vue?vue&type=script&lang=js&"
export * from "./SkeletonPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports